var map = {
	"./icon-BTC.svg": 906,
	"./icon-ETH.svg": 907,
	"./icon-GMX.svg": 476,
	"./icon-GMX_full.svg": 477,
	"./icon-GMX_sm.svg": 478,
	"./icon-GNS.svg": 479,
	"./icon-GNS_full.svg": 480,
	"./icon-GNS_sm.svg": 481,
	"./icon-GNS_v2.svg": 908,
	"./icon-Hegic.svg": 909,
	"./icon-Hegic_circled.svg": 482,
	"./icon-Hegic_full.svg": 483,
	"./icon-Hegic_sm.svg": 484,
	"./icon-Lyra.svg": 910,
	"./icon-Lyra_circled.svg": 485,
	"./icon-Lyra_full.svg": 486,
	"./icon-Lyra_sm.svg": 487,
	"./icon-Premia.svg": 911,
	"./icon-USDC.svg": 912,
	"./icon-WBTC.svg": 913,
	"./icon-WETH.svg": 914,
	"./icon-accordion-arrow.svg": 915,
	"./icon-aggregator.svg": 488,
	"./icon-bin.svg": 280,
	"./icon-btn-up.svg": 393,
	"./icon-calendar.svg": 394,
	"./icon-call-active.svg": 395,
	"./icon-call.svg": 396,
	"./icon-date.svg": 489,
	"./icon-dollar.svg": 916,
	"./icon-down-small-white.svg": 490,
	"./icon-down-small.svg": 397,
	"./icon-down.svg": 917,
	"./icon-edit.svg": 94,
	"./icon-hint.svg": 918,
	"./icon-link.svg": 375,
	"./icon-market.svg": 237,
	"./icon-medium.svg": 919,
	"./icon-put-active.svg": 398,
	"./icon-put.svg": 399,
	"./icon-repay.svg": 920,
	"./icon-settings.svg": 400,
	"./icon-sort.svg": 921,
	"./icon-user.svg": 922,
	"./icon-wallet.svg": 374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;